import { Dispatch, SetStateAction } from 'react';

import { Pivot } from 'hamburger-react';

import * as S from './Hamburger.styles';

type HamburgerProps = {
  isOpen: boolean;
  isOpenSet: Dispatch<SetStateAction<boolean>>;
};

const defaultProps: Partial<HamburgerProps> = {};

export function Hamburger(props: HamburgerProps): React.ReactElement {
  const { isOpen, isOpenSet } = { ...defaultProps, ...props };

  return (
    <S.Wrapper>
      <Pivot color={isOpen ? '#f5f5f5' : '#333333'} toggled={isOpen} toggle={isOpenSet} />
    </S.Wrapper>
  );
}
